import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './dictionary';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/en';

Vue.use(VueI18n);

const locale = 'de';

const i18n = new VueI18n({
	silentTranslationWarn: true,
	locale,
	messages,
});

dayjs.locale(locale);

export default i18n;
